import React from "react";
import { ColorPicker } from "Source/globalComponents";

class Color extends React.Component {
    render() {
        return (
            <div class="formSection">
                <div class="formContainer colorPicker">
                    <label>Color Indicator <sup>*</sup></label>
                    <ColorPicker 
                        onSelect={this.props.onChangeColor} 
                        color={this.props.color} 
                        placeholder={"#000000"} 
                        required={true} 
                    />
                </div>
            </div>
        );
    }
}

export default Color;
